import { render, staticRenderFns } from "./customisations.vue?vue&type=template&id=602be8b4&lang=pug&"
import script from "./customisations.vue?vue&type=script&lang=js&"
export * from "./customisations.vue?vue&type=script&lang=js&"
import style0 from "./customisations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports